<template>
  <v-card>
    <app-title>Upload Logo</app-title>
    <v-subheader>
      <h3>Please Note: Recommended Image size to be : 400px x 400px</h3>
    </v-subheader>
    <file-uploader></file-uploader>
  </v-card>
</template>

<script>
import FileUploader from "@/components/FileUploader";
export default {
  name: "UploadLogo",
  components: { FileUploader }
};
</script>

<style scoped>
</style>